import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import toast from 'react-hot-toast';
import { RefreshCw, Lock } from 'lucide-react';

const StripePaymentForm = ({ onSuccess, onCancel, planName }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsProcessing(true);
        const loadToast = toast.loading('Processando pagamento...');

        // Confirma o pagamento usando os dados inseridos no PaymentElement
        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Return URL é necessário para alguns métodos de pagamento (como Pix/Boleto ou 3D Secure),
                // mas podemos tentar manter na mesma página se for cartão sem 3DS, 
                // porém o Stripe exige uma return_url caso a ação seja redirecionada.
                return_url: `${window.location.origin}/assinatura?payment=success`,
            },
            redirect: 'if_required'
        });

        if (error) {
            toast.error(error.message || 'Erro ao processar pagamento.', { id: loadToast });
            setIsProcessing(false);
        } else if (paymentIntent && paymentIntent.status === 'succeeded') {
            toast.success('Pagamento confirmado com sucesso!', { id: loadToast });
            setIsProcessing(false);
            if (onSuccess) onSuccess();
        } else {
            // Em caso de necessitar de ações adicionais que não puderam ser tratadas sem redirect
            toast.success('Pagamento pendente de confirmação.', { id: loadToast });
            setIsProcessing(false);
            if (onSuccess) onSuccess();
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <h3 style={{ margin: '0 0 5px 0', color: '#0f172a' }}>Completar Assinatura</h3>
                <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>{planName}</p>
            </div>

            {/* Componente seguro do Stripe que renderiza opções de Cartão, Pix, Boleto dependendo do painel */}
            <PaymentElement />

            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                <button
                    type="button"
                    onClick={onCancel}
                    disabled={isProcessing}
                    style={{
                        flex: 1, padding: '12px', border: '1px solid #cbd5e1', backgroundColor: 'white',
                        color: '#475569', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer'
                    }}
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    disabled={!stripe || isProcessing}
                    style={{
                        flex: 1, padding: '12px', border: 'none', backgroundColor: '#ee4d2d',
                        color: 'white', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer',
                        display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px'
                    }}
                >
                    {isProcessing ? <RefreshCw size={18} className="animate-spin" /> : <Lock size={18} />}
                    Confirmar Pagamento
                </button>
            </div>
        </form>
    );
};

export default StripePaymentForm;
